export default __webpack_public_path__ + "static/media/UK02.f7975e3e.mp3";